import * as vp from 'vopay';
import { FunctionComponent, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import styles from './AccountingSystemScheduleSidebar.module.scss';

const { SubTitle, Button, DatepickerSimple } = vp;

type AccountingSystemScheduleSidebarProps = {
  isVisible: boolean;
  defaultDate?: string;
  onSchedule: (savedValues: string) => void;
  close: () => void;
};
type FC = FunctionComponent<AccountingSystemScheduleSidebarProps>;

const AccountingSystemScheduleSidebar: FC = ({
  isVisible,
  close,
  defaultDate,
  onSchedule,
}: AccountingSystemScheduleSidebarProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'AccountingSystem.OpenTab.ScheduleSidebar' });
  const [currentDate, setCurrentDate] = useState(defaultDate || '');

  return (
    <div className={[styles.sidebar, isVisible ? styles.show : ''].join(' ')}>
      {/* I know that the fonts are different from the Figma designs, but currently
      we're undergoing a redesign, so just leaving it as-is for now. */}
      <SubTitle subTitle={t('title', { defaultValue: 'Schedule Pay Date' })} center fontSize="16px" />

      <DatepickerSimple
        name="scheduledDate"
        variant="outline"
        isInline
        value={currentDate || ''}
        onBlur={() => {}}
        min={vp.createTimestamp(moment().startOf('day').toDate().getTime())}
        onChange={(event) => {
          const selectedDate = event.target.value;
          setCurrentDate(selectedDate);
        }}
      />

      <div className={styles.ctaButtons}>
        {/* I know that the fonts are different from the Figma designs, but currently
      we're undergoing a redesign, so just leaving it as-is for now. */}
        <Button
          id="save-schedule-date"
          label={t('scheduleAll', { defaultValue: 'Schedule All' })}
          color="primary"
          onClick={() => {
            onSchedule(currentDate);
          }}
          width="100%"
        />
        <Button id="confirmationDialogue-close" color="secondary" label={t('cancel', { defaultValue: 'Cancel' })} width="100%" onClick={close} />
      </div>
    </div>
  );
};

export default AccountingSystemScheduleSidebar;
